<template>
  <div>

    <div class="Dialog tips region" v-if="isShown">
      <div class="inner">
        <!-- <i class="close" @click="closeZoneRole"></i> -->
        <div class="title">切换大区</div>
        <div class="content">
          <div class="pop-info">
            <p v-if="gameInfo.gameType!=gameTypeEnums.PC_GAME">
              <span>平台</span>
              <select>
                <option v-if="loginState.accountType=='qq' && userAgent.iOS">iOS-QQ</option>
                <option v-if="loginState.accountType=='qq' && userAgent.android">安卓-QQ</option>
                <option v-if="loginState.accountType=='wechat' && userAgent.iOS">iOS-微信</option>
                <option v-if="loginState.accountType=='wechat' && userAgent.android">安卓-微信</option>
              </select>
            </p>
            <p v-if="zoneInfo">
              <span>大区</span>
              <select v-model="selectedZoneInfo"
                      @change="changeZone(selectedZoneInfo)">
                <option disabled value="">请选择大区</option>
                <option v-for="(zone,index) in zoneInfo" :key="index" :value="zone">{{ zone.zone_name }}</option>
              </select>
            </p>
            <p v-if="roleInfo">
              <span>角色：</span>
              <select v-model="selectedRole" @change="changeRole(selectedRole)">
                <option v-for="(role,index) in roleInfo" :key="index" :value="role">{{ role.name }}</option>
              </select>
            </p>
          </div>
        </div>
        <label for="term_auth">
          <div class="region-check">
            <input id="term_auth" type="checkbox" v-model="agreeStatus">
            <p>授权本页面获取您的游戏信息：分区、 角色、背包数据及游戏好友关系链</p>
          </div>
        </label>
        <div class="tips-btn">
          <div :class="['tips-btn-t', agreeStatus? '' : 'tips-btn-t-ash']" @click="onConfirm">确认</div>
          <!-- <div class="tips-btn-b">狠心解散</div> -->
        </div>
      </div>
    </div>


    <toast style="z-index: 99999" :toast-msg="toastMsg"></toast>
  </div>

<!--  <div>-->

<!--    &lt;!&ndash; 区服弹窗 &ndash;&gt;-->
<!--    <div class="pop1" v-if="isShown"-->
<!--         style="position: fixed; top: 50%; left: 50%; -webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%);; z-index: 999;">-->
<!--      <div class="zd"></div>-->
<!--      <a href="javascript:void 0;" @click="closeZoneRole" class="close pa db">关闭</a>-->
<!--      <p class="login_tit">选择区服</p>-->
<!--      <ul class="Choice">-->
<!--        <li v-if="zoneInfo">-->
<!--          <span>大区：</span>-->
<!--          <select v-model="selectedZoneInfo"-->
<!--                  @change="changeZone(selectedZoneInfo)">-->
<!--            <option disabled value="">请选择大区</option>-->
<!--            <option v-for="(zone,index) in zoneInfo" :key="index" :value="zone">{{ zone.zone_name }}</option>-->
<!--          </select>-->
<!--        </li>-->
<!--        <li v-if="roleInfo">-->
<!--          <span>角色：</span>-->
<!--          <select v-model="selectedRole" @change="changeRole(selectedRole)">-->
<!--            <option v-for="(role,index) in roleInfo" :key="index" :value="role">{{ role.name }}</option>-->
<!--          </select>-->
<!--        </li>-->
<!--      </ul>-->
<!--      <p class="login_tit2">绑定角色无法更改，请谨慎选择</p>-->
<!--      <a href="javaScript:void 0;" @click="onConfirm" class="confirm popbtn">确认</a>-->
<!--    </div>-->

<!--    <div v-if="isShown"-->
<!--         style="background-color: rgb(17, 17, 17); border-top: 1px solid rgb(17, 17, 17); position: absolute; z-index: 998; width: 100%; left: 0px; top: 0px; opacity: 0.7; display: block;"-->
<!--         :style="{height:maskHeight+'px'}"></div>-->
<!--    <toast :toast-msg="toastMsg"></toast>-->
<!--  </div>-->
</template>

<script>
import Toast from "./Toast.vue"
import { mapGetters, mapState, mapActions } from "vuex"
import localStorage from "../../bargain/utils/localStorage"
import * as url from "../../bargain/utils/url"
import * as config from "../config"

export default {
  name: "ZoneRole",
  props: ["isSwitchable", "onSelectRole", "isShown", "hideClose", "maskHeight"],
  components: {
    Toast
  },
  data() {
    return {
      zoneInfo: "",
      selectedZoneInfo: "",
      supportRole: false,
      hasNoRoles: false,
      roleInfo: "",
      selectedRole: "",
      toastMsg: "",
      gameTypeEnums: config.GAME_TYPE,
      agreeStatus: false
    }
  },
  computed: {
    ...mapState(["userAgent", "isInMSDK", "gameInfo"]),
    ...mapGetters(["offerId", "loginState"])
  },
  mounted() {
    if (!this.isInMSDK) {
      let defaultSelectedZone = null
      try {
        defaultSelectedZone = localStorage.get(
          `team_pk_zone_${this.offerId}_${this.loginState.openid}_${this.userAgent.weixin ? "wx" : "qq"}`,
          true
        )
      } catch (error) {
        console.log(error)
      }

      if (defaultSelectedZone) {
        // 如果有缓存大区信息，说明之前用户同意过授权
        this.agreeStatus = true
      }

      if (config.GAME_TYPE.PC_GAME == this.gameInfo.gameType) {
        this.getPCZoneInfo().then(res => {
          this.zoneInfo = res.zone_list
          if (!defaultSelectedZone) {
            this.hasNoRoles = true
            this.showZoneRole()
          } else {
            this.setSelectedZone(defaultSelectedZone)
            this.selectedZoneInfo = defaultSelectedZone
            let defaultSelectedRole = localStorage.get(
              `team_pk_role_${this.offerId}_${this.loginState.openid}_${this.userAgent.weixin ? "wx" : "qq"}`,
              true
            )
            this.changeZone(defaultSelectedZone, defaultSelectedRole)
            this.onSelectRole && this.onSelectRole()
          }
        })
      } else {
        // 手游活动，如果不在移动端，则无法选择大区
        if (!this.userAgent.android && !this.userAgent.iOS) {
          return
        }

        if (!defaultSelectedZone) {
          Promise.all([this.getZoneInfo(), this.getUserRecommendZone()]).then(results => {
            if (results[1].recomm_info && results[1].recomm_info.part) {
              let recommendZone = this.zoneInfo.filter(zone => {
                return zone.zone_id == results[1].recomm_info.part
              })[0]
              if (recommendZone) {
                this.changeZone(recommendZone)
              } else {
                this.hasNoRoles = true
              }
            } else {
              this.hasNoRoles = true
            }
            this.showZoneRole()
          })
        } else {
          this.getMobileZoneInfo().then(res => {
            this.zoneInfo = res.zone_list
          })
          this.setSelectedZone(defaultSelectedZone)
          this.selectedZoneInfo = defaultSelectedZone

          this.changeZone(defaultSelectedZone)

          this.onSelectRole && this.onSelectRole()
        }
      }
    } else {
      this.getMobileZoneInfo().then(zones => {
        let zoneid = url.getParam("partition")
        // let currentPartition = url.getParam("partition")
        this.selectedZoneInfo = zones.zone_list.filter(zone => {
          return zone.zone_id == zoneid
        })[0]

        this.getMobileRoleInfo({
          zoneid
        }).then(this.handleRoleInfo)
        this.setSelectedZone(this.selectedZoneInfo)
        this.onSelectRole && this.onSelectRole()
      })
    }
  },
  methods: {
    ...mapActions([
      "getMobileZoneInfo",
      "getUserRecommendZone",
      "getMobileZoneInfo",
      "getMobileRoleInfo",
      "setSelectedRole",
      "setSelectedZone",
      "getRoleInfoByPartition",
      "setPartitionInfo",
      "setSupportRole",
      "reportUserAction",
      "getPCZoneInfo",
      "getPCGameRoleInfo"
    ]),
    getZoneInfo() {
      return this.getMobileZoneInfo().then(res => {
        this.zoneInfo = res.zone_list
      })
    },
    handleRoleInfo(res, selectedRole) {
      this.supportRole = res.support_role == 1
      this.setSupportRole(res.support_role == 1)
      this.setPartitionInfo(res.partition_info)
      let rolesArr = []
      res.role_info.forEach(role => {
        if (role) {
          rolesArr.push({ name: decodeURIComponent(role.role_name), id: role.role_id })
        }
      })
      if (rolesArr.length == 0) {
        this.hasNoRoles = true
        this.toastMsg = "你在此区无游戏角色"
        setTimeout(() => {
          this.toastMsg = null
        }, 2000)
      } else {
        this.hasNoRoles = false
        this.roleInfo = rolesArr
        if (rolesArr.some(role => role.id == selectedRole?.id)) {
          this.selectedRole = selectedRole
        } else {
          this.selectedRole = rolesArr[0]
        }
        this.setSelectedRole(this.selectedRole)
      }
    },
    changeZone(zone, selectedRole) {
      // this.hasNoRoles = true
      // this.selectedRoleName = ""
      if (config.GAME_TYPE.PC_GAME == this.gameInfo.gameType) {
        this.getPCGameRoleInfo({ zoneid: zone.zone_id })
          .then(res => {
            this.selectedZoneInfo = zone
            this.setPartitionInfo({
              area: zone.zone_id
            })
            this.handlePCRoleInfo(res, selectedRole)
          })
          .catch(res => {
            this.toastMsg = res.msg || "查询角色系统繁忙，请稍候再试！"
            setTimeout(() => {
              this.toastMsg = null
            }, 2000)
            this.hasNoRoles = true
            this.selectedRole = null
          })
      } else {
        this.getMobileRoleInfo({ zoneid: zone.zone_id })
          .then(res => {
            // this.setSelectedZone(zone)
            this.selectedZoneInfo = zone
            this.handleRoleInfo(res, selectedRole)
          })
          .catch(res => {
            if (res.ret == 1220) {
              this.toastMsg = "你在此区无游戏角色"
            } else {
              this.toastMsg = res.msg || "查询角色系统繁忙，请稍候再试！"
            }
            setTimeout(() => {
              this.toastMsg = null
            }, 2000)
            this.hasNoRoles = true
            this.selectedRole = null
          })
      }
    },
    changeRole(role) {
      this.setSelectedRole(role)
    },
    handlePCRoleInfo(res, selectedRole) {
      this.setSupportRole(true)
      let rolesArr = []
      res.role_list.forEach(role => {
        if (role) {
          rolesArr.push({ name: decodeURIComponent(role.role_name), id: role.role_id })
        }
      })
      if (rolesArr.length == 0) {
        this.hasNoRoles = true
        this.toastMsg = "你在此区无游戏角色"
        setTimeout(() => {
          this.toastMsg = null
        }, 2000)
      } else {
        this.hasNoRoles = false
        this.roleInfo = rolesArr
        if (rolesArr.some(role => role.id == selectedRole?.id)) {
          this.selectedRole = selectedRole
        } else {
          this.selectedRole = rolesArr[0]
        }
        this.setSelectedRole(this.selectedRole)
      }
    },
    showZoneRole() {
      this.$emit("update:isShown", true)
    },
    closeZoneRole() {
      this.$emit("update:isShown", false)
    },
    onConfirm() {
      if (!this.agreeStatus) {
        this.toastMsg = "请选择有角色的大区并勾选授权确认"
        setTimeout(() => {
          this.toastMsg = null
        }, 2000)
        return
      }

      if (!this.hasNoRoles) {
        this.setSelectedZone(this.selectedZoneInfo)
        this.closeZoneRole()
        this.onSelectRole && this.onSelectRole()
      } else {
        this.toastMsg = "请选择有角色的大区"
        setTimeout(() => {
          this.toastMsg = null
        }, 2000)
      }
    }
  }
}
</script>

<style scoped>
</style>
